<template>
    <div class="w-full h-12 bg-transparent text-gray-400 flex items-center justify-center">
        <div class="text-base">
            Made with love in Geneva, Switzerland. By
            <a class="underline font-bold" href="https://www.linkedin.com/in/jcburolleau/" target="_blank">me</a>
        </div>
    </div>
</template>
